
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="grand">

        <div class="parent1">
              
                  <div class="child1">
                  <h4>Up Coming Front End Developer</h4>
                  

                </div>
                <div class="child2">
                  <h1 class="firstname">I'm Bakare</h1> 
                    <h1>Bidemi</h1>
                    <br/>
                </div>
                <div class="child3">
                  <button id="btn1">More About me</button>
                  <button id="btn2">Hire me</button>
                </div>
             
            </div>

        <div class="parent2">
            <div class="child4">
              <img src="bidemi-removebg-preview.png" alt="my"></img>
            
          </div> 
        </div> 

        

      </div>

      
    </div>
  );
}

export default App;
